import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import Orders from '@flc/components/orders/orders';
import Order from '@flc/components/orders/order';
import ImportTrucks from '@flc/components/import/trucks';
import ImportTruck from '@flc/components/import/truck';
import ImportConsignments from '@flc/components/import/consignments';
import DeliveryTrucks from '@flc/components/delivery/trucks';
import DeliveryTruck from '@flc/components/delivery/truck';
import Remainings from '@flc/components/remainings/remainings';
import Files from '@flc/components/files/files';
import Notifications from '@flc/components/notifications/notifications';
import Info from '@src/flc/components/info/info';
import User from '@flc/components/user/user';
import BillHeaders from '@flc/components/bill-headers/bill-headers';
import TransactionsHistory from '@flc/components/transactions-history/transactions-history';
import BalanceDetails from '@flc/components/balances/balance-details';
import LoadingPlans from '@flc/components/loading-plans/loading-plans';

import MainLayout from '@flc/main-layout';

import RedirectRoute from '@controls/redirect-route';

import { IUserSession } from '@entities/user-session';
import { UserType } from '@enums/user-type';

interface IAppRoutes {
    userSession: IUserSession;
    appVersion: string | undefined;
}

const AppRoutes = (props: IAppRoutes) => {
    const { userSession, appVersion } = props;

    let defaultRoute;

    if (userSession.userSettings?.showOrders) {
        if (userSession.type === UserType.MainClient || userSession.type === UserType.SubClient) {
            defaultRoute = <Route index element={<Navigate replace to={`/flc/orders`} />} />;
        } else if (userSession.type === UserType.Supplier || userSession.type === UserType.Employee) {
            defaultRoute = <Route index element={<Navigate replace to={`/flc/import`} />} />;
        }
    } else if (userSession.userSettings?.showInventory) {
        defaultRoute = <Route index element={<Navigate replace to={`/flc/remainings`} />} />;
    } else if (userSession.userSettings?.showBills) {
        defaultRoute = <Route index element={<Navigate replace to={`/flc/billheaders`} />} />;
    } else if (userSession.userSettings?.showBalances) {
        defaultRoute = <Route index element={<Navigate replace to={`/flc/balances`} />} />;
    }

    return (
        <Routes>
            <Route path='/' element={<MainLayout appVersion={appVersion} />}>
                {defaultRoute}

                {/* TODO: remove redirect section */}

                <Route path='orders' element={<RedirectRoute replace to={`/flc/orders`} />} />
                <Route path='orders/:id' element={<RedirectRoute replace to={`/flc/orders/:id`} />} />

                <Route path='import' element={<RedirectRoute replace to={`/flc/import`} />} />
                <Route path='import/:id' element={<RedirectRoute replace to={`/flc/import/:id`} />} />
                <Route path='import/consignments/:truckId' element={<RedirectRoute replace to={`/flc/import/consignments/:truckId`} />} />

                <Route path='delivery' element={<RedirectRoute replace to={`/flc/delivery`} />} />
                <Route path='delivery/:id' element={<RedirectRoute replace to={`/flc/delivery/:id`} />} />

                <Route path='remainings' element={<RedirectRoute replace to={`/flc/remainings`} />} />
                <Route path='notifications' element={<RedirectRoute replace to={`/flc/notifications`} />} />
                <Route path='files' element={<RedirectRoute replace to={`/flc/files`} />} />
                <Route path='contacts' element={<RedirectRoute replace to={`/flc/contacts`} />} />
                <Route path='useraccount' element={<RedirectRoute replace to={`/flc/useraccount`} />} />
                <Route path='billheaders' element={<RedirectRoute replace to={`/flc/billheaders`} />} />
                <Route path='balances' element={<RedirectRoute replace to={`/flc/balances`} />} />
                <Route path='transactions' element={<RedirectRoute replace to={`/flc/transactions`} />} />

                {/* TODO: remove redirect section */}

                <Route path='flc/orders' element={<Orders />} />
                <Route path='flc/orders/:id' element={<Order />} />

                <Route path='flc/import' element={<ImportTrucks />} />
                <Route path='flc/import/:id' element={<ImportTruck />} />
                <Route path='flc/import/consignments/:truckId' element={<ImportConsignments />} />

                <Route path='flc/delivery' element={<DeliveryTrucks />} />
                <Route path='flc/delivery/:id' element={<DeliveryTruck />} />

                <Route path='flc/remainings' element={<Remainings />} />

                <Route path='flc/notifications' element={<Notifications />} />
                <Route path='flc/files' element={<Files />} />

                <Route path='flc/info' element={<Info />} />

                <Route path='flc/useraccount' element={<User />} />

                <Route path='flc/billheaders' element={<BillHeaders />} />

                <Route path='flc/balances' element={<BalanceDetails />} />
                <Route path='flc/transactions' element={<TransactionsHistory />} />

                <Route path='flc/loadingplans' element={<LoadingPlans />} />
            </Route>
        </Routes>
    );
};

export default AppRoutes;
